'use strict';

exports.__esModule = true;
exports.default = triggerBrowserReflow;

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

module.exports = exports['default'];



// WEBPACK FOOTER //
// ./app/praece-react-bootstrap/lib/utils/triggerBrowserReflow.js